import { Autocomplete } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import React, { memo } from 'react';

const AutocompleteByOptions = ({
  id,
  value,
  onChange,
  options,
  size = 'small',
  placeholder = 'Select option...',
  sx = {},
  multiple = false,
  disabled = false,
}) => {
  return (
    <Autocomplete
      id={id}
      value={value}
      sx={sx}
      multiple={multiple}
      disabled={disabled}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      options={options}
      renderInput={(params) => {
        return (
          <OutlinedInput
            {...params.InputProps}
            inputProps={params.inputProps}
            placeholder={placeholder}
            size={size}
            fullWidth
            variant="outlined"
            endAdornment={<>{params.InputProps.endAdornment}</>}
          />
        );
      }}
    />
  );
};

export default memo(AutocompleteByOptions);
